import { Expose, plainToClassFromExist } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class VatGroupSum {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @Expose()
  net!: number;
  @IsString()
  @Expose()
  vatName!: string;
  @IsNumber()
  @Expose()
  vatAmount!: number;
  @IsNumber()
  @Expose()
  modifier!: number;
  @IsNumber()
  @Expose()
  gross!: number;
}

export class VatGroupSumWithUnmodified extends VatGroupSum {
  unmodifiedModifier!: number;
  unmodifiedGross!: number;
  unmodifiedNet!: number;
  unmodifiedVatAmount!: number;

  static fromVatGroupSum(vatGroupSum: VatGroupSum): VatGroupSumWithUnmodified {
    let vatGroupSumWithUnmodified = new VatGroupSumWithUnmodified();
    vatGroupSumWithUnmodified = plainToClassFromExist(vatGroupSumWithUnmodified, vatGroupSum);
    vatGroupSumWithUnmodified.unmodifiedVatAmount = vatGroupSum.vatAmount;
    vatGroupSumWithUnmodified.unmodifiedGross = vatGroupSum.gross;
    vatGroupSumWithUnmodified.unmodifiedModifier = vatGroupSum.modifier;
    vatGroupSumWithUnmodified.unmodifiedNet = vatGroupSum.net;
    return vatGroupSumWithUnmodified;
  }

  static toVatGroupSum(vatGroupSumWithUnmodified: VatGroupSumWithUnmodified): VatGroupSum {
    let vatGroupSum = new VatGroupSum();
    vatGroupSum = plainToClassFromExist(vatGroupSum, vatGroupSumWithUnmodified);
    return vatGroupSum;
  }
}
